import { getFrame } from '../b24/frame';

export type SignInErrorType = 'timeout' | 'not-installed' | 'auth-invalid' | 'generic';
export class FrameSignInError extends Error { constructor(readonly type: SignInErrorType) { super(type); } }
/** `token` это JWT приложения; токен портала наружу из фрейма уходит только на проверку. */
export interface SignInResult { token: string; user: { id: string; name: string; role: string; isPortalAdmin: boolean }; landing: string }

/**
 * Код карточки-двойника из адреса запуска (…/app?card=forms): запоминаем при загрузке, потому что дальше адрес
 * меняет роутер. У основной карточки кода в адресе нет.
 */
const LAUNCH_CARD = typeof location === 'undefined' ? null : new URLSearchParams(location.search).get('card');
export const launchCard = (): string | null => LAUNCH_CARD ?? (typeof location === 'undefined' ? null : new URLSearchParams(location.search).get('card'));

export async function signInFromFrame(apiBase: string): Promise<SignInResult> {
  let frame;
  try { frame = await getFrame(); } catch { throw new FrameSignInError('timeout'); }
  // Токен фрейма живёт час: после долгой вкладки его отдаёт только обновление у Битрикса.
  const auth = frame.auth.getAuthData() || (await frame.auth.refreshAuth().catch(() => false as const));
  if (!auth) throw new FrameSignInError('auth-invalid');
  const res = await fetch(`${apiBase}/public/b24/sign-in`, {
    method: 'POST', headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ memberId: auth.member_id, authId: auth.access_token, ...(launchCard() ? { card: launchCard() } : {}) }),
  }).catch(() => null);
  if (!res) throw new FrameSignInError('generic');
  if (res.status === 404) throw new FrameSignInError('not-installed');
  if (res.status === 401) throw new FrameSignInError('auth-invalid');
  if (!res.ok) throw new FrameSignInError('generic');
  return res.json() as Promise<SignInResult>;
}
